
const { reducer: homeReducer } = require('./home/redux')
//
const { reducer: productIntroductionReducer, ...productIntroductionActions } = require('./productIntroduction/redux')
const { reducer: aboutUsReducer, ...aboutUsActions} = require('./aboutUs/redux')
const { reducer: servicesReducer, ...servicesActions} = require('./services/redux')
const { reducer: recruitmentReducer, ...recruitmentActions} = require('./recruitment/redux')
const { reducer: qrCodeReducer, ...qrCodeActions} = require('./qrCode/redux')
import commonReducer from 'reducers/commonReducer'

export const reducer = {//全部的根部reducer
  common: commonReducer,
  home: homeReducer,
  productIntroduction:productIntroductionReducer,
  aboutUs:aboutUsReducer,
  services:servicesReducer,
  qrCode:qrCodeReducer,
  recruitment:recruitmentReducer
}

export const actions = {
  ...productIntroductionActions,
  ...aboutUsActions,
  ...servicesActions,
  ...qrCodeActions,
  ...recruitmentActions
}



// WEBPACK FOOTER //
// ./modules/redux.js